<template>
    <div
        class="zedplan-player player"
        data-vjs-player
    >
        <video class="video-js vjs-default-skin vjs-big-play-centered"
               width="100%"
               ref="player"
               muted="muted"
               playsinline
               playsInline
        >
        
        </video>
    </div>
</template>
<script>
import videojs from "video.js";
import "video.js/dist/video-js.css";
import "./../../modules/videojs-quality-selector/plugin.css";
require("./../../modules/videojs-quality-selector/plugin");

import ClickAndHold from "../../modules/ClickAndHold/ClickAndHold";

import { UserVideoConfig } from "../../modules/video/UserVideoConfig";

import inViewport from "vue-in-viewport-mixin";

export default {
  mixins: [inViewport],
  props: {
    data: {
      type: Object,
      required: true,
      validator(data) {
        return true;
        return typeof data.url === String && data.url.length > 0;
      },
    },
    poster: {
      type: String,
      required: false,
    },
    // title: {
    //   type: String,
    //   required: true,
    // },
    // subtitle: {
    //   type: String,
    //   required: true,
    // },
  },
  computed: {
    source() {
      return this.data.playlist_url;
    },
  },
  data() {
    return {
      player: null,
      playing: false,
      asking: false,
      holdingClick: false,
      playingPromise: null,
    };
  },
  methods: {
    initPlayer() {
      this.player = videojs(this.$refs.player, {
        autoplay: false,
        playsinline: true,
        loop: true,
        controls: false,
        languages: {
          es: require("../../lang/videojs/es.json"),
          en: require("../../lang/videojs/en.json"),
          //de: require('../../../lang/videojs/de.json')
        },
        language: this.$i18n.locale,
        techOrder: ["html5"],
        poster: this.poster,
        controlBar: {
          children: [
            "playToggle",
            "progressControl",
            "volumePanel",
            "fullscreenToggle",
          ],
        },
        notSupportedMessage: this.$t("player.not_supported"),
        html5: {
          hls: {
            overrideNative: true,
            limitRenditionByPlayerDimensions: process.env.VUE_APP_AUTO_QUALITY_VIDEO !== "true",
            bandwidth: 6194304
          },
        },
        sources: [
          {
            src: this.source,
            type: "application/x-mpegURL"
          },
        ],
      });

      this.player.QualitySelector({
        // maximumDefaultQuality: {
        //   bitrate: 1536000,
        // },
      });

      this.player.enableTouchActivity();
      this.player.player_.handleTechClick_ = function() {};
    },
    pausePlayer() {
      if (!this.player) return;

      if (this.playingPromise) this.playingPromise.then(() => this.pausePlayer());
      else this.player.pause();

      this.playing = false;
      this.asking = false;
    },
    playPlayer() {
      if (!this.player) return;

      try {
        this.playingPromise = this.player.play().then(() => {
          this.playingPromise = null;
        }).catch(() => {
          this.playingPromise = null;
          this.playing = false;
        });

        this.playing = true;
        this.asking = false;
      } catch (error) {
        console.error(error);
      }
    },
    hardPlay() {
      this.playPlayer();
      this.$emit("videoPriority", this._handler);
    },
    askForPlay() {
      if (this.asking) return;
      this.asking = true;
      this.$emit("videoAppend", this._handler);
    },
    unsetVideo() {
      this.pausePlayer();
      this.$emit("videoRemove");
    },
    _handler(option, value) {
      if (!this.player) return;

      if (option === "play") this.playPlayer();
      else if (option === "pause") this.pausePlayer();
      else if (option === "mute") this.player.muted(value);
    },
  },
  mounted() {
    this.$refs.player.addEventListener(
      "ended",
      () => {
        this.$emit("videoEnded");
      },
      false
    );

    this.$refs.player.addEventListener(
      "play",
      () => {
        this.$emit("videoStarted");
      },
      false
    );

    const ClickHandler = () => {
      if (this.playing) return this.unsetVideo();
      this.hardPlay();
    };
    const TouchHandler = () => {
      if (this.holdingClick) return;
      this.$emit("videoMute");
    };

    if (UserVideoConfig.isMobile) {
      const onActiveHolding = () => {
        this.holdingClick = true;
        this.pausePlayer();
      };
      
      const onReleaseHolding = () => {
        this.playPlayer();
        setTimeout(() => {
          this.holdingClick = false;
        }, 100);
      };

      new ClickAndHold(this.$refs.player, onActiveHolding, onReleaseHolding, 500);
      this.$refs.player.addEventListener("touchend", TouchHandler, false);
    } else {
      this.$refs.player.addEventListener("click", ClickHandler, false);
      }
      
      this.initPlayer();
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
    this.player = null;
  },
  watch: {
    "inViewport.now": function(visible) {
      if (visible) this.askForPlay();
      else this.unsetVideo();
    },
  },
};
</script>

<style scoped lang="scss">
.player {
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
}

.video-js {
  width: 100%;
  background-color: unset;
  height: 100%;

  @media (max-width: 900px) {
    min-height: 300px;
    height: auto;
  }

  @media (max-width: 480px) {
    min-height: 100px;
    height: -webkit-fill-available;
    height: -moz-available;
  }

  .vjs-tech {
    // height: unset;
    height: -webkit-fill-available;
    height: -moz-available;
    position: relative;
    max-height: 90vh;
  }
}
</style>

<style lang="scss">
.video-js {
  .vjs-poster {
    background-size: cover;
  }

  // @media(max-width: 480px){
  //     .vjs-poster{
  //         background-size: cover;
  //     }
  // }

  .vjs-error-display.vjs-modal-dialog {
    background: unset;

    .vjs-modal-dialog-content {
      color: #000a;
    }
  }
}
</style>
